module.exports = __webpack_public_path__ + "img/aboutCommunity.941e57bf.svg";